/* Built In Imports */
/* External Imports */
/* Internal Imports */
/* Components */
import Error404 from '@components/UI/Error404';
// import * as Sentry from '@sentry/browser';
/* Services */

/**
 *
 * @param statusCode
 * @param props
 */
export default function Custom404(statusCode) {
  return <Error404></Error404>;
}
// Custom404.getInitialProps = async contextData => {
//   await Sentry.captureUnderscoreErrorException(contextData);
//   return Error.getInitialProps(contextData);
// };
